import request from "../../utils/request";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const validateInvite = createAsyncThunk(
  "team/validateInvite",
  async (token, { rejectWithValue }) => {
    try {
      const { data } = await request.get(`/teams/invites/validate?token=${encodeURIComponent(token)}`, { withCredentials: true });
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { error: "Invalid or expired invite" });
    }
  }
);

export const acceptInvite = createAsyncThunk(
  "team/acceptInvite",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await request.post("/teams/accept", payload, { withCredentials: true });
      // persist token for Authorization header fallback
      if (data?.token) localStorage.setItem("token", data.token);
      // optionally persist a minimal user for topbar
      localStorage.setItem("memberInfo", JSON.stringify(data.user));
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { error: "Failed to accept invite" });
    }
  }
);

// export const acceptInvite = createAsyncThunk(
//   "team/acceptInvite",
//   async (payload, { rejectWithValue }) => {
//     try {
//       const { data } = await request.post(`/teams/invites/accept`, payload, { withCredentials: true });
//       localStorage.setItem("hostInfo", JSON.stringify(data.user));
//       return data;
//     } catch (err) {
//       return rejectWithValue(err.response?.data || { error: "Accept failed" });
//     }
//   }
// );

export const teamLogin = createAsyncThunk(
  "team/login",
  async ({ hostId, email, password }, { rejectWithValue }) => {
    try {
      const { data } = await request.post(`/teams/login`, { hostId, email, password }, { withCredentials: true });
      localStorage.setItem("hostInfo", JSON.stringify(data.user));
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { error: "Login failed" });
    }
  }
);

export const sendInvite = createAsyncThunk(
  "team/sendInvite",
  async ({ hid, email, allowRoles, defaultRole }, { rejectWithValue }) => {
    try {
      const { data } = await request.post(`/teams/${hid}/invites`, { email, allowRoles, defaultRole }, { withCredentials: true });
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { error: "Invite failed" });
    }
  }
);

export const listMembers = createAsyncThunk(
  "team/listMembers",
  async (hid, { rejectWithValue }) => {
    try {
      const { data } = await request.get(`/teams/${hid}/members`, { withCredentials: true });
      return data.members;
    } catch (err) {
      return rejectWithValue(err.response?.data || { error: "Fetch members failed" });
    }
  }
);
